import { Box, Text, Flex, Button, Heading, Img } from '@chakra-ui/react';
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Image1 from '../../../assets/img/home/home1/TMG_-11 2.svg';
import IconMb from '../../../assets/img/home/home1/Background.png';
import bghome from '../../../assets/img/home/home1/bghome.jpg';
import Union from '../../../assets/img/home/home1/Union.png';
import imagemb from '../../../assets/img/home/home1/movilimage.png';
import { useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { fontSizesByLang } from '../../../helpers/fontSizesByLang';

function HomeSection1() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const fontSizes = fontSizesByLang[i18n.language];

  return (
    <Flex flexDirection={'column'} bg={"#1E1D1D"} height={'100%'}>
      <Flex flexDirection={{ base: 'column', md: 'row' }} align="center" mb={'5%'} justifyContent={'center'} >
        <Flex
          bg={'#3F3F3F'}
          borderRadius={'30px'}
          width={'80%'}
          align={'center'}
          justify={'center'}
          mt={'5%'}
          position="relative"
          overflow="visible"
          height={{md:'400px', lg:'600px', xl:'600px', '2xl': '700px'}}
          ml={'3%'}
        >
          {/* Contenido de texto */}
          <Flex
            flexDirection="column"
            width={{ base: '100%', md:'100%', lg:'100%', xl:'100%', '2xl': '85%' }}
            p={{ base: 4, md: 8 }}
            // justifyContent={'left'}
            display={{ base: 'none', md: 'block' }}
            align={'center'}
          >
            <Text color="white" fontSize={fontSizes.tittlefont} fontWeight="bold" fontFamily={'Roboto Condensed'}>
              {t("home1")}
            </Text>
            <Text color="white" fontSize={fontSizes.tittlefont} fontWeight="bold" fontFamily={'Roboto Condensed'}>
              {t("home2")}
            </Text>
            <Text color="#AE8245" fontSize={fontSizes.tittlefont} fontWeight="bold" fontFamily={'Roboto Condensed'}>
              {t("home3")}
            </Text>
            <Text color="#929292" fontSize={fontSizes.textfont} mt={4} fontFamily={'Inter'} width={'45%'}>
              {t("homeinfo")}
            </Text>
            <Flex align={'center'} gap={5} fontFamily={'Inter'} mt={5}>
              <Img src={IconMb} />
              <Text color={'#AE8245'} fontFamily={'Inter'}>
                +1 956 251 6530
              </Text>
            </Flex>
          </Flex>

          <Flex
            width={{ base: '100%', md: '70%' }}
            justify="center"
            align="center"
            position="absolute"
            right="-11%" 
            top="50%"
            transform="translateY(-50%)"
            zIndex={10}
            display={{ base: 'none', md: 'flex' }}
          >
            <Img src={Image1} width={'120%'} />
          </Flex>
        </Flex>

        {/* vista movil */}

        <Flex display={{ base: 'block', md: 'none' }} flexDirection={'column'} mt={'5%'} >
          <Flex flexDirection={'column'} padding={5} >
            <Text color="white" fontSize={{ base: '4xl' }} fontWeight="bold" fontFamily={'Roboto Condensed'}>
              {t("home1")}
            </Text>
            <Text color="white" fontSize={{ base: '4xl' }} fontWeight="bold" fontFamily={'Roboto Condensed'}>
              {t("home2")}
            </Text>
            <Text color="#AE8245" fontSize={{ base: '4xl' }} fontWeight="bold" fontFamily={'Roboto Condensed'}>
              {t("home3")}
            </Text>
            <Text color="#929292" fontSize={{ base: 'md', md: 'lg', lg: 'xl' }} mt={4} fontFamily={'Inter'}>
              {t("homeinfo")}
            </Text>
          </Flex>
          <Box justifyContent={'right'} height={'300px'} boxSize="300px" >
            <Img src={Image1} width={'100%'} zIndex={5} position={'absolute'} objectFit="cover" objectPosition="right" />
          </Box>

          <Flex align={'center'} gap={5} fontFamily={'Inter'} p={5}  >
            <Img src={IconMb} />
            <Text color={'#AE8245'} fontFamily={'Inter'}>
              +1 1234 234 234
            </Text>
          </Flex>
        </Flex>


      </Flex>
      <Flex
        position="relative"
        width="100%"
        minH={{ base: '70vh', md: '25vh', lg: '33vh' }}
        bgImage={`url(${bghome})`}
        bgSize="cover"
        bgPosition="center"
        justifyContent="space-around"
        align="center"
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bg="rgba(0, 0, 0, 0.5)" // ajusta la opacidad aquí
          zIndex={0}
        />

        <Flex
          justifyContent={{ base: 'center', md: 'space-around' }}
          align="center"
          width="100%"
          flexDirection={{ base: 'column', md: 'row' }}
          textAlign={{ base: 'center', md: 'left' }}
          position="relative"
          gap={{ base: 4, md: 0 }}
          p={{ base: 4, md: 0 }}
        >
          {/* Imagen decorativa */}
          <Img
            src={Union}
            zIndex={1}
            position="absolute"
            left={{ base: '50px', md: '100px', lg: '200px' }}
            top={{ base: '0', md: 'auto' }}
            width={{ base: '100%', md: '20%', lg: '16%', xl:'10%'}}
            height={'auto'}
            opacity={{ base: 1, md: 1 }}
            display={{ base: 'none', md: 'block' }}
          />
          <Img
            src={Union}
            zIndex={1}
            display={{ base: 'block', md: 'none' }}
          />

          {/* Texto */}
          <Text
            color="white"
            zIndex={2}
            fontFamily="Inter"
            fontSize={{ base: '95%', md: '90%', lg: '120%' }}
            maxW={{ base: '90%', md: '60%', lg: '35%' }}
            mt={{ base: 6, md: 0 }}
          >
            {t("home4")}
          </Text>

          {/* Botón */}
          <Button
            width={{ base: '40%', md: '20%', lg: '10%' }}
            fontSize={{ base: '100%', md: '120%' }}
            height={{ base: '45px', md: '15%' }}
            background="#ae8245"
            color="white"
            borderRadius="30px"
            fontFamily="Inter"
            fontWeight="medium"
            _hover={{ bg: '#d8973bff' }}
            padding={3}
            mt={{ base: 3, md: 0 }}
            onClick={() => { navigate("/contact#quote-form"); onClose(); }}
          >
            {t("quote")}
          </Button>
        </Flex>

      </Flex>

    </Flex>
  );
}

export default HomeSection1;
